import {Injectable} from '@angular/core';
import {Response, Http, Headers} from '@angular/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/map';

import { RecoverStatus } from '../interfaces/recover-status';

@Injectable()
export class RecoverPasswordService {

  private url: string = `${ environment.apiRoot }/recoverpassword/`;

  constructor(private http: Http) { }

  public sendRecoverRequest(email:string): Observable<RecoverStatus> {
    const body = JSON.stringify({ email: email });

    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });

    return this.http.post(this.url, body, {headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    let body = res.json();

    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/services/recover-password.service.ts